import React, { useContext } from "react";
import { ContextMessages } from "./messagesContext";
import ProviderMessages from "./messagesProvider";
import "./styles.css";

// Стек тостов в углу экрана; клик по тосту — закрыть.
function MessagesStack() {
    const contextMessages = useContext(ContextMessages);
    if (contextMessages.messages.length === 0) return null;
    return <div className="messages">
        {contextMessages.messages.map((message) =>
            <div
                key={message.id}
                className={`messages__item messages__item_${message.type}`}
                onClick={() => contextMessages.removeMessage(message.id)}
            >
                {message.text}
            </div>
        )}
    </div>;
}

// Оборачивает приложение: провайдер + вывод стека поверх контента.
export default function Messages({ children }) {
    return <ProviderMessages>
        {children}
        <MessagesStack/>
    </ProviderMessages>;
}
